import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { deleteUser } from "../../../api/requests/user-requests";

/**
 * UserDeleteModal – Kullanıcı silme onayı modalı
 *
 * Props:
 * @param {boolean} isOpen       – Modal açık mı?
 * @param {Function} toggle      – Modal'ı kapat/aç
 * @param {object|null} user     – Silinecek kullanıcı nesnesi
 * @param {Function} onConfirm   – Silme işlemi tamamlandığında çalışacak fonksiyon (refresh için)
 */
const UserDeleteModal = ({ isOpen, toggle, user, onConfirm }) => {
    const [isDeleting, setIsDeleting] = useState(false);

    if (!user) return null;

    const handleDelete = async () => {
        setIsDeleting(true);

        try {
            await deleteUser(user.id);
            const message = `${user.username} kullanıcısı başarıyla silindi.`;
            onConfirm({ success: true, message });
        } catch (error) {
            console.error("Kullanıcı silme hatası:", error);
            const errorMessage = error.message || "Kullanıcı silinirken bir hata oluştu.";
            onConfirm({ success: false, message: errorMessage });
        } finally {
            setIsDeleting(false);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>Silme Onayı</ModalHeader>
            <ModalBody>
                <div className="text-center">
                    <i className="bx bx-error-circle text-danger" style={{ fontSize: '48px' }}></i>
                    <h5 className="mt-3">Kullanıcıyı Sil</h5>
                    <p className="mb-2">
                        <strong>{user.username}</strong> kullanıcısını silmek istediğinizden emin misiniz?
                    </p>
                    <small className="text-muted">Bu işlem geri alınamaz.</small>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    color="secondary"
                    className="rounded-pill px-4"
                    onClick={toggle}
                    disabled={isDeleting}
                >
                    İptal
                </Button>
                <Button
                    color="danger"
                    className="rounded-pill px-4"
                    onClick={handleDelete}
                    disabled={isDeleting}
                >
                    {isDeleting ? (
                        <>
                            <i className="bx bx-loader-alt bx-spin me-1"></i>
                            Siliniyor...
                        </>
                    ) : (
                        <>
                            <i className="bx bx-trash me-1"></i>
                            Sil
                        </>
                    )}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default UserDeleteModal;